interface AppLogoProps {
  size?: number;
  /** Use on dark backgrounds — inverts the navy strokes to white */
  inverted?: boolean;
}

export default function AppLogo({ size = 40, inverted = false }: AppLogoProps) {
  const primary = inverted ? '#ffffff' : '#1a1a2e';
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80" width={size} height={size}>
      <path d="M18,62 L34,18" fill="none" stroke={primary}   strokeWidth="4" strokeLinecap="round"/>
      <path d="M24,40 L42,40" fill="none" stroke="#E8A020"   strokeWidth="3.5" strokeLinecap="round"/>
      <path d="M34,18 L50,62" fill="none" stroke={primary}   strokeWidth="4" strokeLinecap="round"/>
      <path d="M42,26 Q58,22 58,32 Q58,40 42,40" fill="none" stroke="#E8A020" strokeWidth="3.5" strokeLinecap="round"/>
      <path d="M42,40 Q26,40 26,52 Q26,62 42,62 L52,62" fill="none" stroke="#E8A020" strokeWidth="3.5" strokeLinecap="round"/>
    </svg>
  );
}
